import Generator from '../../../../Generator'
import Types from '../../../../../actions/Types'

export default Generator.node({
  baseType: Types.PRODUCTS,
  nodeType: Generator.NODETYPE.GET,
  suffixType: 'MINIMAL'
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/products/get/minimal.js